import { IonLabel, useIonPopover } from "@ionic/react";
import { Field, useFormikContext } from "formik";
import { AppFormItem } from "./index";
import { HslColorPicker } from "react-colorful";
import { AppColorPickerPorps } from "../../interfaces/form";
function AppColorPicker({
  name,
  label = undefined,
  presetColors,
  show,
  ...props
}: AppColorPickerPorps) {
  const { handleChange, values } = useFormikContext();
  return (
    <Field
      className="hide-scroll overflow-hidden !w-full"
      component={ColorPickerComponent}
      onChange={(e) => handleChange({ target: { name, value: e } })}
      {...{ name, label, show, presetColors, values, ...props }}
    />
  );
}
const ColorPickerComponent = ({
  form,
  label,
  name,
  field,
  show,
  presetColors,
  values,
  ...props
}) => {
  const isShowing = show && show(field.value, values);
  const [present, dismiss] = useIonPopover(
    <HslColorPicker color={field.value} {...name} {...props} />,
    {
      field,
      name,
      ...props,
    }
  );
  if (isShowing !== undefined && !isShowing) {
    return null;
  }
  return (
    <AppFormItem
      {...{ error: false, focused: false }}
      onClick={(e) =>
        present({
          alignment: "end",
          arrow: true,
          event: e.nativeEvent,
        })
      }
      button
    >
      <IonLabel slot="start">{label ? label : name}</IonLabel>
      <IonLabel
        slot="end"
        className={`h-6 w-6 rounded-full ring-2 ring-gray-600 dark:ring-gray-400`}
        style={{
          background: `hsl(${field.value?.h || 0},${field.value?.s || 0}%,${
            field.value?.l || 0
          }%)`,
        }}
      />
    </AppFormItem>
  );
};
export default AppColorPicker;
